export default "__VITE_ASSET__6deba4cc__"